<template>
  <div class="row no-gutters info_area" style="padding-bottom: 40px">
    <img :src="imageSrc" class="img_icon" :alt="content"/>
    <div class="space"/>
    <div class="content text-white" v-html="content"/>
  </div>
</template>

<script>
export default {
  name: "CustomIconInfo",
  props: {
    imageSrc: {
      type: String,
      required: true,
    },
    content: {
      type: String,
      default: "",
    },
    defaultContent: {
      type: String,
      default: "",
    }
  },
  methods: {}
}

</script>

<style scoped>

.info_area {


}

@media (max-width: 605px) {
  .info_area {
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
}


.img_icon {
  width: 80px;
  height: 80px;
  object-fit: cover; /* 确保图片覆盖整个容器，且保持比例 */
}

@media (max-width: 700px) {
  .img_icon {
    width: 70px;
    height: 70px;
  }
}

.space {
  width: 20px;
  height: 20px;
}

.content {
  font-size: 24px;
  font-weight: 500;
  line-height: 34px;
  letter-spacing: 0.1em;
  text-align: left;
  margin: auto 0;
  width: 160px;
}

@media (max-width: 1035px) {
  .content {
    width: 140px;
    font-size: 20px;
    line-height: 28px;
  }
}


@media (max-width: 605px) {
  .content {
    text-align: center;
  }
}
</style>
